const DuplicateErrorMsg = ({ warning }: DuplicateErrorMsgProps) => {
    return <>Data imported by duplicating Model contains {warning ? "warnings" : "errors"}.</>;
};

interface DuplicateErrorMsgProps {
    warning?: boolean;
}

export default DuplicateErrorMsg;
